import React, { useState } from "react";
import { X, Download } from "lucide-react";
import ApiService from "../../services/Api.service";

const CampaignCreateModal = ({ item, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    campaign_id: item?.id || "",
    file: null,
  });
  const [dragActive, setDragActive] = useState(false);

  const handleFileChange = (file) => {
    if (file) {
      setFormData((prev) => ({ ...prev, file }));
    }
  };

  const handleInputChange = (e) => {
    handleFileChange(e.target.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileChange(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const handleSave = () => {
    if (!formData.file) {
      alert("Please select a file before saving.");
      return;
    }
    onSave(formData);
  };

  const handleDownloadSample = async () => {
    try {
        console.log(item)
        const payload={
        campaign_id:item.id
        }
      const res = await ApiService.getCampaignSampleHeader(payload);
      if (res.status === 200 && res.data.data) {
        const headers = res.data.data.join(",");
        const blob = new Blob([headers], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading sample file", error);
    }
  };

  return (
    <div className="add-subparam-overlay">
      <div className="add-subparam-modal campaign-modal">
        {/* Header */}
        <div className="add-subparam-header">
          <h3>Add New Lead</h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="add-subparam-body">
          {/* Drag & Drop Upload */}
          <div
            className={`upload-box ${dragActive ? "drag-active" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className="upload-label">
              {formData.file ? (
                <span className="file-selected">
                  Selected File: {formData.file.name}
                </span>
              ) : (
                <>
                  <span>Drag & drop your file here or click to upload</span>
                  <small>Supported Format: .csv, .xlsx</small>
                </>
              )}
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".csv,.xlsx"
              onChange={handleInputChange}
              style={{ display: "none" }}
            />
          </div>

          {/* Download Sample Button */}
          <div className="download-sample">
            <button className="download-sample-btn" onClick={handleDownloadSample}>
              <Download size={16} /> Download Sample Format
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="add-subparam-footer">
          <button className="popup-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="popup-add-btn" onClick={handleSave}>
            Add New Lead
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampaignCreateModal;
